export default /* glsl */`
uniform float time;
`;
